import React from "react";
import ModificaProdottiNEW from "../modificaProdotti/ModificaProdottiNEW";
import DBperAreaAnteprimaExport from "./AreaTraduzioniFromPSComponenti/DBperAreaAnteprimaExport";

function AreaAnteprimaExport({product,setProductFunction,utente,tradPermessa,setTradPermessa,setCharCount, charCount, listaNomiProdotto}) {

    

    /////// PROPS ///////////////

    //const utente = props.utente
    

    /////// HOOKS ///////////////




    return (
        <div className='center'>
            <div className='cf'>
                {/* <h1>scegli prod o crea nuovo: [input show or create]</h1> */}
                <div className="fl w-100 w-100-ns">
                {product.codiceVS === "NO DATA" && 
                
                <div className="sfondoBiancoTema">
                        <DBperAreaAnteprimaExport
                            product={product}
                            setProductFunction={setProductFunction}
                            utente={utente}
                            tradPermessa={tradPermessa}
                            setTradPermessa={setTradPermessa}
                            charCount={charCount}
                            setCharCount={setCharCount}
                        />                        
                    </div>}
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    <div className="sfondoBiancoTema">
                    
                    {product.codiceVS !== "NO DATA" && 
                    
                    <ModificaProdottiNEW
                        prodotto={product}
                        setProductFunction={setProductFunction}
                        utente={utente}
                        listaNomiProdotto={listaNomiProdotto}
                        /* listaNomiProdotto={listaNomiProdotto} */
                        />}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AreaAnteprimaExport;
